import React from 'react';
import { Text } from '@chakra-ui/react';
import { formatDocument } from 'utils/documentFormat';

export default function FormattedDocument({ value, fallback = '—', ...textProps }) {
  const display = value ? formatDocument(value) : fallback;
  return <Text {...textProps}>{display}</Text>;
}

export { formatDocument };
